import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientTaskItem } from "./PatientTaskItem";

class PatientTaskListItem implements ITableDataSourceItem<PatientTaskItem> {
    public Model: PatientTaskItem;
    public Name: string;
    public GenericTaskStatusId: string;

    constructor(model: PatientTaskItem) {
        this.Model = model;
    }
}

export { PatientTaskListItem };
